/* CUFF – Geschenkverpackung im Warenkorb-Drawer (Checkbox = Produkt hinzufügen/entfernen) */
(function(){
  var busy=false;
  function root(){ return document.querySelector('[data-cuff-wrap]'); }
  function vid(){ var r=root(); return r ? parseInt(r.dataset.variant,10) : 0; }
  function post(url, body){
    return fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw d; return d; }); });
  }
  /* Drawer neu laden, danach cart:updated, damit Kassen-Button, Summe und Ausblenden aktuell sind */
  function rebuild(){ document.dispatchEvent(new CustomEvent('cart:build')); setTimeout(function(){ document.dispatchEvent(new CustomEvent('cart:updated')); },700); }
  function getCart(){ return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){ return r.json(); }); }

  /* Position in der Artikelliste ausblenden – die Checkbox steht für sie */
  function hideLine(line){
    document.querySelectorAll('#CartDrawer .cart__item').forEach(function(el){
      el.classList.toggle('cuff-wrap-line', !!line && el.getAttribute('data-key')===line.key);
    });
  }

  function sync(cart){
    var r=root(); if(!r || !cart) return;
    var v=vid(), line=null, others=0;
    (cart.items||[]).forEach(function(it){ if(it.variant_id===v){ line=it; } else { others+=it.quantity; } });
    hideLine(line);
    r.hidden = others===0;
    var cb=r.querySelector('[data-cuff-wrap-check]'); if(cb) cb.checked=!!line;
    if(busy) return;
    /* höchstens so viele Verpackungen wie Schmuckstücke; ohne Schmuck keine Verpackung */
    if(line && line.quantity>others){
      busy=true;
      post('/cart/change.js',{id:line.key,quantity: others})
        .catch(function(){}).then(function(){ busy=false; rebuild(); });
    }
  }
  function refresh(){ getCart().then(sync).catch(function(){}); }

  document.addEventListener('change',function(e){
    var cb=e.target && e.target.closest ? e.target.closest('[data-cuff-wrap-check]') : null; if(!cb) return;
    var r=root(), on=cb.checked; busy=true; r.classList.add('is-busy');
    var p = on ? post('/cart/add.js',{items:[{id:vid(),quantity:1}]})
               : getCart().then(function(cart){
                   var line=(cart.items||[]).filter(function(it){ return it.variant_id===vid(); })[0];
                   return line ? post('/cart/change.js',{id:line.key,quantity:0}) : null;
                 });
    p.catch(function(err){ try{ console.warn('CUFF Geschenkverpackung', err); }catch(x){} cb.checked=!on; })
     .then(function(){ busy=false; r.classList.remove('is-busy'); rebuild(); });
  });

  document.addEventListener('cart:updated',function(e){ if(e.detail && e.detail.cart){ sync(e.detail.cart); } else { refresh(); } });
  ['cart:open','ajaxProduct:added','drawerOpen.CartDrawer'].forEach(function(ev){ document.addEventListener(ev,function(){ setTimeout(refresh,250); }); });
  /* Liste wird bei jeder Änderung neu gebaut -> Position erneut ausblenden */
  var t;
  function watch(){
    var list=document.querySelector('#CartDrawer [data-products]');
    if(!list || !window.MutationObserver) return;
    new MutationObserver(function(){ clearTimeout(t); t=setTimeout(refresh,150); }).observe(list,{childList:true});
  }
  function init(){ watch(); refresh(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();

/* CUFF: Gratis-Geschenk entfernen (Monk „Allow gift opt-out“) und wieder hinzufügen */
(function(){
  if(window.__cuffGiftOpt) return; window.__cuffGiftOpt=1;
  var KEY='cuffGiftOptOut';
  var T={de:'Gratis-Geschenk wieder hinzufügen',da:'Tilføj gratis gave igen',nl:'Gratis cadeau weer toevoegen',fr:'Rajouter le cadeau offert',it:'Aggiungi di nuovo il regalo gratuito',es:'Volver a añadir el regalo gratis',en:'Add free gift back'};
  function txt(){ var l=(document.documentElement.lang||'en').slice(0,2).toLowerCase(); return T[l]||T.en; }
  function get(){ try{ return JSON.parse(sessionStorage.getItem(KEY)||'null'); }catch(e){ return null; } }
  function set(v){ try{ if(v) sessionStorage.setItem(KEY,JSON.stringify(v)); else sessionStorage.removeItem(KEY); }catch(e){} }
  function getCart(){ return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){ return r.json(); }); }
  function post(url,data){ return fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)}).then(function(r){ return r.json(); }); }
  function rebuild(){
    if(/\/cart\/?$/.test(location.pathname)){ location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart:build'));
    setTimeout(function(){ document.dispatchEvent(new CustomEvent('cart:updated')); },700);
  }
  function paid(cart){ var s=0; (cart.items||[]).forEach(function(i){ if(i.handle!=='geschenkverpackung' && !(i.properties && i.properties._mr)) s+=i.final_line_price; }); return s; }
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('[data-cuff-gift-remove]');
    if(a){
      e.preventDefault(); if(a.getAttribute('aria-busy')==='true') return; a.setAttribute('aria-busy','true');
      var key=a.getAttribute('data-cuff-gift-remove');
      getCart().then(function(cart){
        var line=(cart.items||[]).filter(function(i){ return i.key===key; })[0];
        if(line) set({v:line.variant_id, p:line.properties||{}, t:paid(cart)});
        return post('/cart/change.js',{id:key,quantity:0});
      }).catch(function(){}).then(rebuild);
      return;
    }
    var b=e.target.closest && e.target.closest('[data-cuff-gift-readd]');
    if(b){
      e.preventDefault(); var s=get(); if(!s || b.getAttribute('aria-busy')==='true') return; b.setAttribute('aria-busy','true');
      post('/cart/add.js',{items:[{id:s.v,quantity:1,properties:s.p}]}).catch(function(){}).then(function(){ set(null); rebuild(); });
    }
  });
  /* Link „wieder hinzufügen“ nur, solange das Geschenk entfernt ist und der Warenkorb noch mindestens so viel wert ist wie beim Entfernen */
  function render(){
    var box=document.querySelector('#CartDrawer [data-products]'); if(!box) return;
    var s=get();
    if(!s){ var o=box.querySelector('.cuff-gift-readd'); if(o) o.remove(); return; }
    getCart().then(function(cart){
      var has=(cart.items||[]).some(function(i){ return i.properties && i.properties._mr; });
      if(has) set(null);
      var p=paid(cart), ok=!has && p>0 && p>=s.t;
      var cur=box.querySelector('.cuff-gift-readd');
      if(!ok){ if(cur) cur.remove(); return; }
      if(!cur){ cur=document.createElement('div'); cur.className='cuff-gift-readd'; cur.innerHTML='<button type="button" data-cuff-gift-readd></button>'; box.appendChild(cur); }
      cur.querySelector('button').textContent='+ '+txt();
    }).catch(function(){});
  }
  var t; function soon(){ clearTimeout(t); t=setTimeout(render,250); }
  document.addEventListener('cart:updated',soon);
  ['cart:open','drawerOpen.CartDrawer'].forEach(function(ev){ document.addEventListener(ev,soon); });
  function watch(){
    var l=document.querySelector('#CartDrawer [data-products]');
    if(!l || !window.MutationObserver) return;
    new MutationObserver(function(ms){
      for(var i=0;i<ms.length;i++){ for(var j=0;j<ms[i].addedNodes.length;j++){ var n=ms[i].addedNodes[j]; if(n.classList && n.classList.contains('cart__items')){ soon(); return; } } }
    }).observe(l,{childList:true});
  }
  if(document.readyState!=='loading'){ watch(); soon(); } else document.addEventListener('DOMContentLoaded',function(){ watch(); soon(); });
})();
